import _ from 'root/libs/exaforte/react/lodash';

export default class DataModel {
    constructor(component, config)
    {
        this.component                      = component;
        this.config                         = {...{name: 'filter', fields: {}, remove_if_empty: true}, ...config};
        this.after_field_change_callback    = _.debounce(this.after_field_change_callback.bind(this), 500);
        this.errors                         = {};
        this.reset                          = this.reset.bind(this);
    }
    
    get_field_props(settings)
    {
        settings    = {...{changeCallbackProp: 'onChangeText', field: null, withValue: true, valueField: 'value', value: this.get_field_data(settings.field), fielddefine: {}}, ...settings};
        let props   = [];
        
        if(_.is_empty(settings.fielddefine) && this.config.fields[settings.field])
            settings.fielddefine = this.config.fields[settings.field];

        props = {...props, ...settings.fielddefine};
        
        if(!settings.changeCallback)
            settings.changeCallback = (val) => { this.set_field_data({field: settings.field, value: val, trigger_after_field_change_update: !props.is_uncontrolled, ...(settings.set_field_data_settings ? settings.set_field_data_settings : {})}); };

        if(this.config.fields[settings.field] && !_.is_empty(this.config.fields[settings.field].value))
            props.placeholder = this.config.fields[settings.field].value;
        
        if(settings.withValue)
            props[settings.valueField] = settings.value;

        if(this.config.fields[settings.field] && !_.is_empty(this.config.fields[settings.field].options))
            props['options'] = this.config.fields[settings.field].options;
        
        props[settings.changeCallbackProp] = settings.changeCallback;
        
        if(this.config.fields[settings.field] && this.config.fields[settings.field].mandatory == 't')
            props.mandatory = true;
        
        if(this.errors[settings.field])
            props.error = this.errors[settings.field];

        return props;
    }
    
    set_fields(fields, settings)
    {
        settings            = {...{set_default_value_for_mandatory_fields: true, set_init_value: true}, ...settings};
        this.config.fields  = fields;
        
        if(settings.set_default_value_for_mandatory_fields)
            this.set_default_value_for_mandatory_fields();
        
        if(settings.set_init_value)
        {
            let init_values = {};

            for(let i in this.config.fields)
                if(!_.is_empty(this.config.fields[i].init_value))
                    init_values[this.config.fields[i].field] = this.config.fields[i].init_value;

            if(!_.is_empty(init_values))
                this.component.setState({[this.config.name]: {...this.component.state[this.config.name], ...init_values}});
        }
    }
    
    set_default_value_for_mandatory_fields()
    {
        for(let i in this.config.fields)
            if(this.config.fields[i].mandatory == 't' && !_.is_empty(this.config.fields[i].value))
                this.set_field_data({...{trigger_after_field_change: false}, ...this.config.fields[i]});
    }
    
    get_fields(settings) {
        settings        = {...{format: null, filter_field: {}}, ...settings};
        let response    = _.pickBy(_.cloneDeep(this.config.fields), _.handle_filter_fields.bind(settings));

        if(settings.format)
        {
            if(_.isString(settings.format))
                response = this['_' + settings.format](response, settings)
            else if(_.isFunction(settings.format))
                response = settings.format(response, settings)
        }
        
        return response;
    }
    
    _asSelectList(response)
    {
        return _.map(response, item => {return {value: item.field, label: item.label}});
    }
    
    set_field_data(settings)
    {
        settings = {...{force_change: false, trigger_after_field_change: true, remove_if_empty: this.config.remove_if_empty}, ...settings};
        
        // Veld kan niet of gefilterd worden
        if(!this.config.fields[settings.field])
            return false;
            
        let current_value = null;
        
        if(this.component.state[this.config.name] && this.component.state[this.config.name][settings.field])
            current_value = _.format_input(_.cloneDeep(this.component.state[this.config.name][settings.field]), {format_numbers: false});

        // Als de waarde niet veranderd is hoeft hij ook niet verder in de code te gaan.
        if(settings.force_change === false && _.isEqual(current_value, _.format_input(_.cloneDeep(settings.value), {format_numbers: false})))
            return false;
        
        if(settings.trigger_after_field_change)
            this.before_update_callback(settings);
        
        this.component.setState((currentState) => {
            let newState = currentState;

            if(!newState[this.config.name])
                newState[this.config.name] = {};
            
            if(!newState[this.config.name][settings.field] && _.is_empty(settings.value))
                settings.trigger_after_field_change = false;
            
            newState[this.config.name][settings.field] = settings.value;

            if(settings.remove_if_empty && _.is_empty(newState[this.config.name][settings.field]))
                delete newState[this.config.name][settings.field];

            return newState;
        }, () => {
            if(settings.trigger_after_field_change)
                this.after_field_change_callback(settings);
        });
    }

    before_update_callback(settings)
    {
        if(this.config.beforeUpdate)
            this.config.beforeUpdate(settings);
    }

    after_field_change_callback(settings)
    {
        if(this.config.onUpdate)
            this.config.onUpdate(settings);
    }
    
    get_field(field)
    {
        return this.config.fields[field];
    }
    
    get_field_data(field, default_value = null)
    {
        return (!this.component.state[this.config.name] || typeof this.component.state[this.config.name][field] === 'undefined' ? default_value : this.component.state[this.config.name][field]);
    }
    
    get_filter(settings)
    {
        settings = {...{remove_if_empty: this.config.remove_if_empty}, ...settings};

        if(!this.component.state[this.config.name])
            return {};
        
        let fields = this.get_fields(settings);

        return _.pickBy(this.component.state[this.config.name], (val, key) => (typeof fields[key] !== 'undefined' && (settings.remove_if_empty == false || !_.is_empty(val))));
    }
    
    set_response(response)
    {
        this.errors = response.errors;

        this.component.forceUpdate();
    }
    
    has_errors() {
        return _.size(this.errors) > 0;
    }
    
    get_errors() {
        return this.errors;
    }
    
    has_warnings() {
        return false;
    }
    
    reset()
    {
        this.component.setState({filter: {}});
        
        this.set_default_value_for_mandatory_fields();
        this.after_field_change_callback();
    }
}